let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("l46gH"), load("hwiu3")]).then(() => parcelRequire('jUOfU'));